import { selectedRiskProfileWorkspaceAtom } from '@app/state/riskAtoms'
import { Button } from '@src/components/ui/button'
import { useAtomValue } from 'jotai'
import { ChartSpline } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import WorkspaceSelector from '../components/WorkspaceSelector'
import { DEFAULT_CAPITAL_TYPE } from '../constants/riskProfile.constants'

const RiskProfilePage = () => {
  const selectedWorkspace = useAtomValue(selectedRiskProfileWorkspaceAtom)
  const navigate = useNavigate()

  const handleViewResults = () => {
    if (selectedWorkspace === null) return

    const searchParams = new URLSearchParams({
      workspace: selectedWorkspace.id,
      capitalType: DEFAULT_CAPITAL_TYPE,
      metric: 'damage_cost',
    })

    navigate(`/app/risk/profile/analysis?${searchParams.toString()}`)
  }

  return (
    <div className="min-h-full bg-background">
      <section className="border-b bg-neutral px-9 py-6">
        <div className="flex flex-col gap-5">
          <div className="flex flex-wrap items-end gap-3">
            <div className="flex gap-x-10">
              <WorkspaceSelector />
            </div>
            <Button type="button" disabled={selectedWorkspace === null} onClick={handleViewResults}>
              View results
            </Button>
          </div>
        </div>
      </section>

      <main className="flex min-h-[520px] flex-col items-center justify-center px-6 py-16">
        <div className="flex max-w-sm flex-col items-center text-center">
          <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-neutral text-primary">
            <ChartSpline className="size-8" />
          </div>
          <h1 className="text-lg font-semibold text-primary">Welcome to Risk Profile</h1>
          <p className="text-sm text-foreground">Select a Workspace above to view results.</p>
        </div>
      </main>
    </div>
  )
}

export default RiskProfilePage
